var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['c-drop-catcher', { active: _vm.active === true }],on:{"drop":_vm.onDrop,"dragenter":function($event){$event.preventDefault();},"dragover":function($event){$event.preventDefault();}}})}
var staticRenderFns = []

export { render, staticRenderFns }